import MaybeTrpcError from "./MaybeTrpcError";
import NetworkRequestError from "./NetworkRequestError";

namespace ErrorUtil {
  export function getErrorProps(error: unknown):
    | {
        publicId: string;
        publicIdShorthand: string;
      }
    | undefined {
    let publicId: string | undefined;
    if (error instanceof NetworkRequestError) {
      publicId = error.getPublicId();
    } else {
      const maybeTrpcError = new MaybeTrpcError(error);
      publicId = maybeTrpcError.getPublicId();
    }

    if (!publicId) {
      return undefined;
    }
    const split = publicId.split("-");
    const publicIdShorthand = split[split.length - 1];

    return {
      publicId,
      publicIdShorthand,
    };
  }
}

export default ErrorUtil;
